<template>
  <div>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          label-position="left"
          class="flex-row-between"
          label-width="70px"
        >
          <el-form-item label="时间段" style="margin-right: 40px">
            <el-date-picker
              style="width: 340px"
              v-model="date"
              size="mini"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="费用来源">
            <el-select
              style="width: 180px"
              size="mini"
              v-model="type"
              placeholder="请选择"
            >
              <el-option
                v-for="item in followupTypes"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button size="mini" type="primary" @click="startFilter()"
          >搜索</el-button
        >
        <el-button size="mini" @click="clearFilter">清空</el-button>
      </div>
    </div>
    <div class="panel mt-20">
      <div class="header">
        <h2>共计费用：￥{{ this.totalAmount }}</h2>
      </div>
      <el-table
        v-if="!isMobile()"
        :data="followups"
        stripe
        style="width: 100%"
        key="followups"
      >
        <el-table-column prop="origin" label="费用类型">
          <template slot-scope="scope">
            <span>{{ followupTypeMap[scope.row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="user" label="人员" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.user.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="金额(元)"
          width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="发生日期"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.created_at) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="item in followups">
          <div>{{ followupTypeMap[item.type] }}</div>
          <div>金额：￥{{ item.amount }}</div>
          <div class="flex-row-between font-12">
            <span>人员：{{ item.user.name }}</span>
            <span>{{ formatTime(item.date) }}</span>
          </div>
        </li>
      </ul>
      <div v-if="followups.length == 0 && isMobile()" class="text-info-12">
        暂未创建费用。
      </div>
      <el-pagination
        class="mt-20"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { customerFollowupList } from '../../service/getData'
import { formatTime } from '@/util/index'
import { CustomerFollowupTypes } from '@/config/global'
import { clone } from '@/util'
import { isMobile } from '../../util'

export default {
  props: {
    customerID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isMobile,
      formatTime,
      followupTypes: clone(CustomerFollowupTypes),
      followups: [],
      total: 0,
      type: 0,
      date: null,
      totalAmount: 0,
      pageSize: 20,
      currentPage: 1,
    }
  },
  computed: {
    followupTypeMap() {
      let map = {}
      this.followupTypes.map((item) => {
        map[item.value] = item.label
      })
      return map
    },
  },
  watch: {
    currentPage() {
      this.requestCustomerFollowups()
    },
  },
  created() {
    this.followupTypes.unshift({
      label: '所有类型',
      value: 0,
    })
    this.requestCustomerFollowups()
  },
  methods: {
    refresh() {
      this.clearFilter()
    },
    async requestCustomerFollowups() {
      let data = {
        page: this.currentPage - 1,
        size: this.pageSize,
        amount_mini: 1,
        type: this.type,
        customer_id: this.customerID,
      }
      if (this.date) {
        data.start_date = this.date[0]
        data.end_date = this.date[1]
      }

      let res = await customerFollowupList(data)
      if (res.code == 0) {
        this.followups = res.data.list
        this.total = res.data.total
        this.totalAmount = res.data.total_amount
      }
    },
    startFilter() {
      this.currentPage = 1
      this.requestCustomerFollowups()
    },
    clearFilter() {
      this.date = null
      this.type = 0
      this.currentPage = 1
      this.requestCustomerFollowups()
    },
  },
}
</script>

<style scoped>
</style>